import React from "react";
import { Helmet } from "react-helmet-async";
import { H1 } from "theme/components/atoms/Typography/Heading";
import Body, { BodyParagraph } from "theme/components/atoms/Typography/Body";
import Logo from "theme/components/atoms/Logo";
import { useIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  seoTitle: {
    id: "pages.Maintenance.seoTitle",
    defaultMessage: "503 - Currently unavailable",
  },
  title: {
    id: "pages.Maintenance.title",
    defaultMessage: "The website is currently unavailable",
  },
  content: {
    id: "pages.Maintenance.content",
    defaultMessage:
      "Our service team has been dispatched to bring it back online.",
  },
});

const Maintenance = () => {
  const intl = useIntl();
  return (
    <div className="wrapper">
      <Helmet>
        <title>{intl.formatMessage(messages.seoTitle)}</title>
        <meta httpEquiv="refresh" content="5" />
      </Helmet>

      <div className="header">
        <div className="container header__container">
          <div className="header__logo">
            <Logo />
          </div>
        </div>
      </div>
      <div className="mdl-layout__content">
        <div className="page-content">
          <div className="container">
            <H1>{intl.formatMessage(messages.title)}</H1>
            <BodyParagraph>
              <Body>{intl.formatMessage(messages.content)}</Body>
            </BodyParagraph>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
